
















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Test } from '@shared/types/database'
import { Card } from '@alpha/ink'

@Component({
  components: { Card }
})
export default class RelatedTests extends Vue {
  @Prop({ default: null }) relatedTests!: Test[]
}
